var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { isLeadFormSuppressed, leadSubmitted, ctaTextButtonClass, emailTxtOverrideWidth, leftButtonTitle, ctaEmailButtonClass, footerMultiButtonObj } = options; 
__p+='\n\n';
 if (!isLeadFormSuppressed) { 
__p+='\n  <a href="javascript:void(0);" class="js-hide-ajax-fail ';
 if (leadSubmitted) { 
__p+=' contacted ';
 } else { 
__p+=' js-qv-contact-agent ';
 } 
__p+=' text-button  '+
((__t=( ctaTextButtonClass ))==null?'':__t)+
'  ';
 if (emailTxtOverrideWidth) { 
__p+=' email-text-buttons-equal ';
 } 
__p+=' email-button-left" ';
 if (!leadSubmitted) { 
__p+=' data-omtag="ldp:quickview:stickyfooter:contact-agent" data-formid="secondary" ';
 } 
__p+=' sticky-contact-agent>\n    ';
 if (leadSubmitted) { 
__p+=' Contacted ';
 } else { 
__p+='  Email ';
 } 
__p+='\n  </a>\n  ';
 } 
__p+='\n<a href="javascript:void(0);" data-target="#textInputModal" data-toggle="modal" data-lead-position="qv-footer" class="js-hide-ajax-fail btn '+
((__t=( ctaEmailButtonClass ))==null?'':__t)+
'  ';
 if (!MOVE.Helper.isMobile()) { 
__p+=' round-cta ';
 } 
__p+=' btn-primary email-button ';
 if (emailTxtOverrideWidth) { 
__p+=' email-text-buttons-equal ';
 } else { 
__p+=' ab-cta-v2';
 } 
__p+='js-text-leads" id="qv-sticky-text-cta" data-omtag="ldp:persistant-footer:text-agent">\n  Text\n</a>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/optimization/qv-text-and-email-buttons.jst.ejs